
<app-accordion-default
  titulo="Triagem inicial"
  [isOpen]="panelOpenState"
  [lista]="triagemInicial"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<!---->
<app-accordion-default
  titulo="Dados biopsicossociais"
  [isOpen]="panelOpenState"
  [lista]="bioPsicossocial"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<!---->
<app-accordion-default
  titulo="Avaliação da dor"
  [isOpen]="panelOpenState"
  [lista]="avaliacaoDaDor"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<!---->
<mat-accordion>
  <mat-expansion-panel hideToggle style="pointer-events: none">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">
        @if(detalhesTriagem.escalaEva === 'EVA Baixa') {
        <img src="../../../../../assets/svg/icons/eva_baixa_ic.svg" alt="" />
        EVA Baixa }

        <!---->
        @if(detalhesTriagem.escalaEva === 'EVA Moderada') {
        <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt="" />
        EVA Moderada }

        <!---->
        @if(detalhesTriagem.escalaEva === 'EVA Intensa') {
        <img src="../../../../../assets/svg/icons/eva_intensa_ic.svg" alt="" />
        EVA Intensa }
      </mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</mat-accordion>
<div class="spacer" style="height: 1em"></div>

<!---->
<mat-accordion>
  <mat-expansion-panel hideToggle style="pointer-events: none">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">
        @if(detalhesTriagem.risco === 'Baixo risco') {
        <img src="../../../../../assets/svg/icons/eva_baixa_ic.svg" alt="" />
        Baixo risco para fatores físicos e psicossociais relacionados à dor
        lombar }

        <!---->
        @if(detalhesTriagem.risco === 'Médio risco') {
        <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt="" />
        Médio risco para fatores físicos e psicossociais relacionados à dor
        lombar}

        <!---->
        @if(detalhesTriagem.risco === 'Alto risco') {
        <img src="../../../../../assets/svg/icons/eva_intensa_ic.svg" alt="" />
        Alto risco para fatores físicos e psicossociais relacionados à dor
        lombar }
      </mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</mat-accordion>
<div class="spacer" style="height: 1em"></div>

<!---->
<app-accordion-default
  titulo="Finalização"
  [isOpen]="panelOpenState"
  [lista]="finalizacao"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>